//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    togglesArrayCondensed,
    staticOptionsArray,
    typeOptionsArray
} from "./consts";
import AQInput from "../../../../../components/Generics/AQInput/AQInput.vue";
import AQBadge from "../../../../../components/Generics/AQBadge/AQBadge.vue";
import AQChip from "../../../../../components/Generics/AQChip/AQChip.vue";

export default {
    components: {
        AQChip,
        AQInput,
        AQBadge
    },
    data() {
        return {
            localValue: "",
            compModel2: "",
            tooltip: "full class name",
            staticOptions: staticOptionsArray,
            toggleArray: [],
            staticBadge: "",
            inputType: "",
            typeOptions: typeOptionsArray,
            toggles: togglesArrayCondensed
        };
    },
    computed: {
        hasAfter() {
            return !!this.toggleArray.find(elem => elem === "hasAfter");
        },
        hasBefore() {
            return !!this.toggleArray.find(elem => elem === "hasBefore");
        },
        hasBeforeLabel() {
            return this.toggleArray.find(elem => elem === "hasBeforeLabel");
        },
        hasPlaceholder() {
            return this.toggleArray.find(elem => elem === "hasPlaceholder");
        },
        hasPrefix() {
            return !!this.toggleArray.find(elem => elem === "hasPrefix");
        },
        hasSuffix() {
            return !!this.toggleArray.find(elem => elem === "hasSuffix");
        },
        isClearable() {
            return !!this.toggleArray.find(elem => elem === "isClearable");
        },
        hasStaticBadge() {
            return !!this.toggleArray.find(elem => elem === "hasStaticBadge");
        },
        hasType() {
            return this.toggleArray.find(elem => elem === "hasType");
        },
        hasError() {
            return !!this.toggleArray.find(elem => elem === "hasError");
        },
        hasErrorLabel() {
            return this.toggleArray.find(elem => elem === "hasErrorLabel");
        },
        textareaFixedHeight() {
            return this.toggleArray.find(elem => elem === "textareaFixedHeight");
        },
        textareaAutogrow() {
            return this.toggleArray.find(elem => elem === "textareaAutogrow");
        },
        isDisabled() {
            return !!this.toggleArray.find(elem => elem === "isDisabled");
        },
        isReadonly() {
            return !!this.toggleArray.find(elem => elem === "isReadonly");
        },

        compStacklabel() {
            return !!this.toggleArray.find(elem => elem === "hasStackLabel");
        },
        compFloatLabel() {
            return this.toggleArray.find(elem => elem === "hasFloatLabel");
        },
        compModel() {
            return this.toggleArray.find(elem => elem === "hasValue") || this.localValue;
        },
        isDense() {
            return !!this.toggleArray.find(elem => elem === "isCondensed");
        },
        compTitle() {
            return this.toggleArray;
        }
    },
    methods: {
        resetToggles() {
            this.toggleArray = [];
        }
    }
};
